import { all, call, put, takeLatest } from 'redux-saga/effects';

import api from 'api';

import { IFeaturesResponse } from 'types/features';

import { setFeatures, setFeaturesLoaded } from './actions';
import { FETCH_FEATURES_REQUEST } from './actionTypes';

function* getFeatures() {
    try {
        const response: IFeaturesResponse = yield call(api.features.getFeatures);

        // The server sends an array of enabled keys (`["main_plan"]`); the store
        // and `canAccess` expect a map keyed by feature. Normalize here so the
        // lookup `features[key]` resolves.
        const enabled = Object.fromEntries((response?.features ?? []).map((key) => [key, true]));

        yield put(setFeatures(enabled));
    } catch {
        // Fail closed: feature-gated items stay hidden, but the gate opens so the cabinet renders.
        yield put(setFeatures({}));
    } finally {
        yield put(setFeaturesLoaded(true));
    }
}

export default function* watchFeatures() {
    yield all([takeLatest(FETCH_FEATURES_REQUEST, getFeatures)]);
}
